<template>
    <div
        class="screen-ratio-[2:1]:max-w-none screen-ratio-[2:1]:py-2 h-full px-4 py-2 lg:px-8 lg:py-6"
    >
        <slot />
    </div>
</template>